<template>
	<div class="triangle-image" :style="backgroundStyle">
		<div class="triangle-image-body" :style="bodyStyle">
			<h1
				v-if="title"
				v-html="title"
        class="triangle-title"
			>
			</h1>
			<p v-if="subtitle">
				<span v-html="subtitle"></span>
			</p>
			<div v-if="giftcard">
				<CTA
					isArrowDown
					:content="`Ordina ora`"
					@click="triggerAction"
				/>
			</div>
			<div v-if="giftcardDiscount">
				<CTA
					isArrowDown
					:content="`Approfittane ora`"
					@click="triggerAction"
				/>
			</div>
		</div>
	</div>

</template>

<script>

export default {
	props: {
		title: {
			type: String,
			default: null
		},
		subtitle: {
			type: String,
			default: null
		},
		backgroundStyle: {
			type: Object,
			default () {
				return null
			}
		},
		bodyStyle: {
			type: Object,
			default () {
				return null
			}
		},
		giftcard: {
			type: Boolean,
			default: false
		},
		giftcardDiscount: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		triggerAction() {
			window.dispatchEvent(new CustomEvent('scroll-to-recipient', { bubbles: true }));
		}
	}
}

</script>

<style scoped>
h1 {
	font-weight: 600;
}

.triangle-image {
	background-size: cover;
	position: relative;
	padding: 240px 0;
	background-position: center center;
	background-repeat: no-repeat;
	background-color: transparent;
}
.triangle-image:before {
	left: 0;
	border-right: 20px solid transparent;
}
.triangle-image:after {
	right: 0;
	border-left: 20px solid transparent;
}
.triangle-image:before, .triangle-image:after {
	content: '';
	display: block;
	position: absolute;
	bottom: 0;
	width: 50%;
	border-bottom: 20px solid;
  border-bottom-color:var(--quomi-bg);
}
.triangle-image-body {
	position: absolute;
	left: 50%;
	top: 50%;
	bottom: auto;
	right: auto;
	transform: translateX(-50%) translateY(-50%) translateY(20px);
	width: 90%;
	max-width: 1200px;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.triangle-image-body h1 {
	color: #ffffff;
	text-shadow: 3px 3px 7px black;
	font-family: var(--quomi-cursive-font);
	font-size: 50px;
}
.triangle-image-body p {
	color: #ffffff;
	text-shadow: 3px 3px 7px black;
	font-size: 20px;
	font-weight: 700;
}

@media (max-width: 1024px) {
	.triangle-image {
		min-height: 320px;
		padding: 60px 0;
	}

  .triangle-image-body h1 {
    font-size: 35px;
  }

  .triangle-image-body p {
    font-size: 17px;
  }
}

@media only screen and (min-width: 768px) {
	.triangle-image-body  {
		width: 90%;
	}


}

</style>
